import { VisitorsEmailsState } from 'store/visitors-emails/types';
import { AttendeeType } from 'store/transactions/types';
import { FormattedAttendees } from 'store/cart/types';

export const formatAttendees = (visitors: VisitorsEmailsState, type: AttendeeType): Array<FormattedAttendees> => {
  if (!visitors) return [];

  return Object.entries(visitors).map(([, visitor]) => ({
    email: visitor.email,
    type,
    first_name: visitor.firstName,
    last_name: visitor.lastName,
  }));
};
